import React from "react";
import { TableCell, TableRow, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import Dialog from "../dialog";
import { formatDatetime } from "../../utils/setting";
import { styles } from "./styles";
class CustomerFeedbackItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.confirmDeleteFeedback = this.confirmDeleteFeedback.bind(this);
  }
  confirmDeleteFeedback() {
    this.mDialog.handleDialogOpen();
  }
  render() {
    const { feedback, classes, remove, t, selectFeedback } = this.props;
    return (
      <React.Fragment key={feedback._id}>
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("cancel")}
          agree={t("agree")}
          title={t("confirm")}
          content={t("customer_remove_feedback_confirm")}
          action={() => {
            remove(feedback._id);
            this.mDialog.handleDialogClose();
          }}
        />
        <TableRow className={classes.root}>
          <TableCell>
            <img
              className={classes.containerImageRound}
              src={feedback.avatar || "/images/noneImage.svg"}
            />
            <b>{feedback.name}</b>
          </TableCell>
          <TableCell>{feedback.email}</TableCell>
          <TableCell>
            {feedback.phone
              ? `(${feedback.countryCode}) ${feedback.phone}`
              : ""}
          </TableCell>
          <TableCell>{formatDatetime(feedback.createdAt)}</TableCell>
          <TableCell align="center">
            <IconButton
              color="primary"
              onClick={() => {
                selectFeedback(feedback);
              }}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              color="secondary"
              onClick={() => {
                this.confirmDeleteFeedback();
              }}
            >
              <DeleteIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
}
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

CustomerFeedbackItem.propTypes = {
  feedback: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    countryCode: PropTypes.string,
    phone: PropTypes.string,
    createdAt: PropTypes.number,
  }),
  selectFeedback: PropTypes.func,
  remove: PropTypes.func,
};

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(CustomerFeedbackItem)));
